import Component from "gia/Component";
import { CardHoverBase } from "./Common";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    gsap.delayedCall(0.1, () => CardHoverBase(this.DOM.view));
  }
}
